import React, { useEffect, useState } from "react";
import { api, thumbUrl, API } from "@/lib/api";
import { Link } from "react-router-dom";

function formatPrice(p, currency = "gbp") {
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: currency.toUpperCase() }).format(p);
  } catch {
    return `£${Number(p).toFixed(2)}`;
  }
}

export default function MyPurchases() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/me/purchases").then((r) => setOrders(r.data)).catch(() => setOrders([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 mt-8 pb-24" data-testid="my-purchases-page">
      <div className="border-b border-white/10 pb-6 mb-10">
        <p className="text-xs uppercase tracking-[0.3em] text-white/40">Your collection</p>
        <h1 className="font-serif text-4xl md:text-5xl font-light mt-2">My Photos</h1>
      </div>

      {loading ? (
        <p className="text-white/50 text-sm uppercase tracking-[0.3em]">Loading…</p>
      ) : orders.length === 0 ? (
        <div className="text-center py-24">
          <p className="text-white/50 mb-6">You haven't purchased any photos yet.</p>
          <Link to="/" className="text-white underline-offset-4 hover:underline" data-testid="empty-browse-link">Browse the latest shots →</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {orders.map((o) => (
            <div key={o.id} className="border border-white/10" data-testid={`purchase-${o.id}`}>
              <img src={thumbUrl(o.image_id)} alt={o.image_title} className="w-full aspect-[4/5] object-cover" />
              <div className="p-5 space-y-3">
                <h3 className="font-serif text-2xl">{o.image_title}</h3>
                <p className="text-xs text-white/50">
                  {formatPrice(o.amount, o.currency)} · {new Date(o.created_at).toLocaleDateString()}
                </p>
                <a
                  href={`${API}/orders/${o.id}/download?token=${encodeURIComponent(o.download_token)}`}
                  className="block w-full text-center bg-white text-black py-3 text-xs uppercase tracking-[0.3em] hover:bg-white/90 transition"
                  data-testid={`download-${o.id}`}
                >
                  Download original
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
